import React from 'react'
import Wrapper from './Wrapper.js'

export default () => (
	<Wrapper>
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130">
			<line x1="64.5" y1="43.5" x2="64.5" y2="86.5" stroke="currentColor" strokeWidth="7" />
			<path d="M108.1,86.5v-11.5c0-5.5-4.5-10-10-10h-67.2c-5.5,0-10,4.5-10,10v11.5" fill="none" stroke="currentColor" strokeWidth="7" />
			<rect x="46" y="86.5" width="37" height="37" />
			<rect x="46" y="6.5" width="37" height="37" />
			<rect x="2.4" y="86.5" width="37" height="37" />
			<rect x="89.6" y="86.5" width="37" height="37" />
		</svg>
	</Wrapper>
)
